module.exports = __webpack_public_path__ + "static/media/uncommon_booster.742c8222.webp";